import { type FC, useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'

interface Props {
  onChange: (change: string) => void
  onDelete: () => void
}

const ChildrenItem: FC<Props> = ({ onChange, onDelete }) => {
  const [value, setValue] = useState('')
  const handleChange = (input: string) => {
    setValue(input)
    onChange(input)
  }

  return (
    <Box paddingBottom="s16" gap="s8" flexDirection="row" alignItems="center">
      <TextField value={value} onChange={handleChange} mandatory />
      <Button onClick={onDelete} type="secondary" iconName="delete" />
    </Box>
  )
}

export default ChildrenItem
